export const NBA_STANDINGS_COMPARISON = [
  {
    label: 'Record',
    keys: ['short_record'],
  },
  {
    label: 'Away/Home',
    keys: ['short_away_record', 'short_home_record'],
  },
  {
    label: 'Last 10',
    keys: ['last_ten_games_record'],
  },
  {
    label: 'Streak',
    keys: ['streak'],
  },
];

export const MLB_STANDINGS_COMPARISON = [
  {
    label: 'Record',
    keys: ['short_record'],
  },
  {
    label: 'Away / Home',
    keys: ['short_away_record'],
  },
  {
    label: 'L10',
    keys: ['last_ten_games_record'],
  },
  {
    label: 'Streak',
    keys: ['streak'],
  },
];

export const NCAAB_STANDINGS_COMPARISON = [
  {
    label: 'Record',
    keys: ['short_record'],
  },
  {
    label: 'Away/Home',
    keys: ['short_road_record', 'short_home_record'],
  },
  {
    label: 'Streak',
    keys: ['streak'],
  },
];

export const NHL_STANDINGS_COMPARISON = [
  {
    label: 'Record',
    keys: ['short_record'],
  },
  {
    label: 'Away/Home',
    keys: ['short_road_record', 'short_home_record'],
  },
  {
    label: 'Last 10',
    keys: ['last_ten_games_record'],
  },
  {
    label: 'Streak',
    keys: ['streak'],
  },
];

export default {
  nba: NBA_STANDINGS_COMPARISON,
  wnba: NBA_STANDINGS_COMPARISON,
  ncaab: NCAAB_STANDINGS_COMPARISON,
  wcbk: NCAAB_STANDINGS_COMPARISON,
  nhl: NHL_STANDINGS_COMPARISON,
  mlb: MLB_STANDINGS_COMPARISON,
};
